import React, { Component } from "react";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import close from "../../static/images/close.png";
import "./index.css";
@observer
class SampleQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionList: [
        "示例问题1: 工作节奏挺好的，岗位方向也是越来越吃香的，但是总想去工资最高的岗位，又怕现在没有什么积累",
        "示例问题2: 午休时间不想跟同事一起吃饭，中午休息时间只想一个人吃饭玩手机休息，但是又不想显得不合群。怎么办",
        "示例问题3: 人到中年，精力上镜争不过年轻人，经历上镜争不过更自身的人，怎么建立自己的价值位置，提高职场竞争力",
        "示例问题4: 最近业务部门变化较大，感觉做的事很有可能是徒劳，该怎么应对？",
      ],
    };
  }

  close = () => {
    this.props.close(false);
  };

  render() {
    return (
      <div className="sample_w">
        <div className="sample_c">
          <div className="title">
            <span>提问题的Tips</span>
            <img
              src={close}
              alt=""
              onClick={() => {
                this.close();
              }}
            />
          </div>
          <ul>
            <li>
              在“
              <font color="#02B0EC" style={{ fontWeight: "bold" }}>
                现状
              </font>
              ”与“
              <font color="#02B0EC" style={{ fontWeight: "bold" }}>
                目标/诉求
              </font>
              ”中，您一定遇到了什么“
              <font color="#02B0EC" style={{ fontWeight: "bold" }}>
                障碍/挑战
              </font>
              ”，所以心里感觉到苦闷。建议您可以清晰地描述出
              <font color="#02B0EC" style={{ fontWeight: "bold" }}>
                现状、目标/诉求、障碍/挑战
              </font>
              ，才能让解忧人更好地理解您的困惑哦！
            </li>
            <li>
              问题范例：（
              <font color="#02B0EC" style={{ fontWeight: "bold" }}>
                目标
              </font>
              ）我原本是希望自己每天下班后可以花1小时阅读，（
              <font color="#02B0EC" style={{ fontWeight: "bold" }}>
                现状
              </font>
              ）但是我现在每次到家就想滑手机，（
              <font color="#02B0EC" style={{ fontWeight: "bold" }}>
                挑战
              </font>
              ）因为我感觉上班已经花费很多精力，就很难专注阅读，真的很困扰。
            </li>
            {/* {this.state.questionList.map((item, index) => (
                            <li key={index}                            >
                                {item}
                            </li>
                        ))} */}
          </ul>
        </div>
      </div>
    );
  }
}
export default withRouter(SampleQuestion);
